import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface TipoServicio {
  idServicio: number;
  descripcion: string;
  fecha_creacion: string;
  fecha_actualizacion: string;
  estadoServicio: number;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class TipoServicioService {
  private apiUrl =  `${environment.apiUrl}/api/tiposervicio`; 
  //private apiUrl = 'http://localhost:3000/api/tiposervicio';

  constructor(private http: HttpClient) {}

  // Crear un tipo de servicio
  createTipoServicio(tipoServicio: TipoServicio): Observable<TipoServicio> {
    return this.http.post<TipoServicio>(this.apiUrl, tipoServicio, {
      withCredentials: true
    }).pipe(
      catchError(error => {
        let message = 'Error en la solicitud.';
        if (error.status === 400 && error.error?.message === 'Este tipo de servicio ya está registrado.') {
          message = 'Este tipo de servicio ya está registrado.';
        }
        return throwError(() => new Error(message));
      })
    );
  }

  // Obtener todos los tipos de servicio
  getTipoServicios(): Observable<TipoServicio[]> {
    return this.http.get<TipoServicio[]>(this.apiUrl, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Obtener tipo de servicio por ID
  getTipoServicioById(id: number): Observable<TipoServicio> {
    return this.http.get<TipoServicio>(`${this.apiUrl}/${id}`, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Actualizar tipo de servicio
  updateTipoServicio(id: number, tipoServicio: TipoServicio): Observable<TipoServicio> {
    return this.http.put<TipoServicio>(`${this.apiUrl}/${id}`, tipoServicio, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Inactivar tipo de servicio
  inactivarTipoServicio(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/inactivar`, { estadoServicio: 0 }, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Activar tipo de servicio
  activarTipoServicio(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/activar`, { estadoServicio: 1 }, {
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  // Manejo de errores
  private handleError(error: any) {
    console.error('Ocurrió un error:', error);

    let message = error.message || 'Error en la solicitud.';

    if (error.status === 500 && error.error?.error?.name === 'SequelizeUniqueConstraintError') {
      message = 'Este tipo de servicio ya está registrado.';
    }

    return throwError(() => new Error(message));
  }
}
